// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import formatAntennas from '../formatAntennas'

/**
 * if it's a back-to-back, it'll have two antennas.
 * separate the antennas so that they are assigned to separate segment ends.
 * example [[Site 1, Passive 1], [Passive 2, Site 2]]
 * Passive 1 and 2 share all the same information but they have different antennas
 * which 'point' to their respective segment ends (Site 1 and Site 2)
 * @param {Array} antennas - list of Passive Repeater Antennas to be split up
 * @returns {{p1Antenna, p2Antenna}}
 */
const splitPassiveRepeaterAntennaIntoSegmentEndAntenna = antennas => {
  const intermediateP1Antennas = [{ ...antennas[0] }]
  const intermediateP2Antennas = [
    // if it's a billboard, we'll have a secondSegmentEndAntennaId stored on the first antenna
    antennas.length === 1
      ? {
        ...antennas[0],
        segmentEndAntennaId: antennas[0].secondSegmentEndAntennaId,
      } : {
        ...antennas[1],
      },
  ]

  const p1Antenna = formatAntennas(intermediateP1Antennas)
  const p2Antenna = formatAntennas(intermediateP2Antennas)

  // NOTE - we do not want to pass the transmit mode of passive repeater antennas.
  // Instead we allow the backend to set these based on the path's site antennas configuration
  // This way we do not accidentally set Tx/Rx on passive segment ends which are coupled with site 2
  // on simplex paths.
  delete p1Antenna[0].mode
  delete p2Antenna[0].mode

  return {
    p1Antenna,
    p2Antenna,
  }
}

export default splitPassiveRepeaterAntennaIntoSegmentEndAntenna
